import React from 'react';

export const pageMeta = {
  "name": "JSON HTML",
  "link": "/javascript/json/html"
};

export default function JavascriptJsonHtml() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JSON HTML</h2>
      <p>Route: /javascript/json/html</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
